export function createRequireDependency(deps, context) {
    return function requireDep(name) {
        const fn = deps[name];
        if (typeof fn !== 'function') {
            throw new Error(String(context) + ': deps.' + name + ' is required');
        }
        return fn;
    };
}
